import React from 'react'

import MainLayout from '../layouts/MainLayout'
import ShoppingList from '../components/ShoppingList'

export default function() {
  return (
    <MainLayout>
      <ShoppingList />
    </MainLayout>
  )
}
